var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.84 602.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#35a7ff;}.cls-3{fill:#ffe74c;}.cls-4{fill:#ff5964;}.cls-5{fill:#6bf178;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.86,356q0,4.69-6.22,12.31Q434.31,432.42,344.74,432q-91.62-.4-148.32-63.22-55.23-60.74-54.82-153,.41-89.28,55-151.3Q253.57-.38,341.09,0,436.24.43,490,59.11q5.84,6.48,5.82,11.48,0,5.58-20.6,41.31T449.37,152a8,8,0,0,1-5.89,2.33q-1.47,0-14.63-11.82-15.8-14.16-31-22.16a105.29,105.29,0,0,0-48.11-12q-43.17-.19-69.16,32-23.91,29.85-24.11,73.9-.21,44.64,23.45,75,25.69,33,68.87,33.21a109.18,109.18,0,0,0,48.5-10.95,149.52,149.52,0,0,0,30.64-20.42q13-11.1,14.44-11.1c2,0,3.91,1.1,5.86,3.26q4.67,5.31,25.38,36.82Q494.87,352.81,494.86,356Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 421.73,
    cy: 536.64,
    r: 65.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.31,413.25C55.7,395.44,91.91,309,135.09,354.3S95.58,435.78,73.31,413.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.73,22.81C78.1,2.28,169.6,22.39,132.82,73S45.57,48.76,63.73,22.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.94,139.91c8.57-28.84,120.44-40.69,97.77,30.93S-9.89,176.38.94,139.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.45,278.88c-1.85-27.37,90-73.07,93.36-4.68S8.8,313.48,6.45,278.88Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.91bc083688789257c6fc2987bb45442e.svg";
export { ForwardRef as ReactComponent };